import React from "react";

const AppDesignFace = () => {
  return (
    <div style={{ color: "white", fontFamily: "Arial, sans-serif" }}>
      <h2 style={{ color: "#00ffff", borderBottom: "2px solid #00ffff", paddingBottom: "10px" }}>
        🎨 UI/UX & App Design
      </h2>
      <p style={{ marginTop: "15px", opacity: 0.9 }}>
        Diseño de interfaces intuitivas y estéticas con un enfoque en la experiencia del usuario (UX) y la identidad visual tecnológica (High-Tech Design).
      </p>
      <div style={{ marginTop: "20px" }}>
        <h3 style={{ color: "#00ffff", fontSize: "16px" }}>Core Design:</h3>
        <ul style={{ fontSize: "14px", opacity: 0.8 }}>
          <li>Prototipado avanzado en Figma y Adobe XD.</li>
          <li>Sistemas de diseño (Design Systems) escalables.</li>
          <li>Interfaces oscuras (Dark UI) y Glassmorphism.</li>
        </ul>
      </div>
      <div style={{ marginTop: "25px", padding: "15px", background: "rgba(0, 255, 255, 0.1)", borderRadius: "12px", border: "1px dashed #00ffff" }}>
        <h4 style={{ margin: "0 0 10px 0", color: "#00ffff", fontSize: "14px" }}>🚀 Producto de FrancoLab:</h4>
        <p style={{ fontSize: "13px", margin: "0 0 10px 0" }}>
          <strong>FrancoUI System:</strong> Una librería de componentes React listos para aplicaciones Web3 de alto nivel.
        </p>
        <a href="#" style={{ color: "#00ffff", fontSize: "13px", fontWeight: "bold", textDecoration: "none" }}>Ver Case Study →</a>
      </div>
    </div>
  );
};

export default AppDesignFace;